import React from "react";
import styles from "./SkeletonColumn.module.scss";

const SkeletonColumn = () => (
  <div className={styles.col}>
    <div className={`${styles.sk} ${styles.title}`} />
    <div className={`${styles.sk} ${styles.line}`} />
    <div className={`${styles.sk} ${styles.line2}`} />
    <div className={`${styles.sk} ${styles.priceLine}`} />
    <div className={`${styles.sk} ${styles.button}`} />
    <div className={`${styles.sk} ${styles.feature}`} />
    <div className={`${styles.sk} ${styles.feature}`} />
    <div className={`${styles.sk} ${styles.feature}`} />
    <div className={`${styles.sk} ${styles.feature}`} />
  </div>
);

export default SkeletonColumn;
